import React, { FC } from 'react'
import renderSection from '@components/ui/Page/utils'

export interface ProductPageSectionsProps {
  productData: any
}

const ProductPageSections: FC<ProductPageSectionsProps> = ({ productData }) => {
  if (!productData) return null

  const sections: Array<{ condition: boolean; section: any; index: number }> = [
    { condition: !!productData?.prodValueTicker, section: { className: 'product', ...productData?.prodValueTicker }, index: 0 },
    { condition: !!productData?.fourColumnUpOrderTeaserTwo, section: { className: 'product', ...productData?.fourColumnUpOrderTeaserTwo }, index: 1 },
    { condition: !!productData?.press, section: { className: 'product', ...productData?.press }, index: 2 },
    { condition: !!productData?.threeColumnList, section: { className: 'product', ...productData?.threeColumnList }, index: 3 },
    { condition: !!productData?.fourColumnUp, section: { className: 'product', ...productData?.fourColumnUp }, index: 4 },
    { condition: !!productData?.twoColumnUp, section: { className: 'product', ...productData?.twoColumnUp }, index: 5 },
    { condition: !!productData?.featureComparison, section: { className: 'product', ...productData?.featureComparison }, index: 6 },
    { condition: !!productData?.valueTicker, section: { className: 'product', ...productData?.valueTicker }, index: 7 },
    { condition: !!productData?.generic_faqs && !productData?.generic_faqs.topPosition, section: { colorDark: productData?.color_dark, className: 'product', ...productData?.generic_faqs }, index: 8 },
    { condition: !!productData?.generic_faqs && !!productData?.generic_faqs.topPosition, section: { colorDark: productData?.color_dark, className: 'product', ...productData?.generic_faqs }, index: 9 },
    { condition: !!productData?.fourColumnUpOrderTeaser, section: { className: 'product', ...productData?.fourColumnUpOrderTeaser }, index: 10 },
    { condition: !!productData?.centeredIcon, section: { className: 'product', ...productData?.centeredIcon }, index: 11 },
    { condition: !!productData?.reviews, section: { className: 'product', ...productData?.reviews }, index: 12 },
    { condition: !!productData?.productTeaser, section: { className: 'product', ...productData?.productTeaser }, index: 13 },
    { condition: !!productData?.teaser, section: { colorLight: productData?.color_light, className: 'product', ...productData?.teaser }, index: 14 },
  ]

  return (
    <div className={'product ' + (productData?.alternative_layout ? 'alternative_layout' : '')}>
      {sections.filter(s => s.condition).map(s => renderSection(s.section, s.index))}
    </div>
  )
}

export default ProductPageSections
